import axios from '../../../services/axios';
import { TestTemplateBody } from '../types/TestTemplateBody';
import { TypeOfGoalBody } from '../types/TypeOfGoalBody';
import { TypeOfSubjectBody } from '../types/TypeOfSubjectBody';
import { ContentSubType } from '../types/ContentSubTypeBody';
import { TypeOfTestTemplateBody } from '../types/TypeOfTestTemplateBody';
import { axiosNTL, axiosNT } from '../../../services/axios';
import { TEST_TEMPLATE_CONFIG } from '../../../constants/comman';



let getTestTemplateList = (skip: number = 0, type : string = '', typeId?: string,serachQuery?:string) => {
    let API =  `rule/getRule?skip=${skip}&limit=10&type=${type}&typeId=${typeId}`;
    if(serachQuery){
        API=API+`&searchQuery=${serachQuery}`;
    }
    return axiosNT.get(API)
        .then((res: any) => {
            let testList: TestTemplateBody[] = res.responseObject;
            return Promise.resolve(testList);
        });
}

let submitNewTemplate = (testTemplateRequest: TestTemplateBody) => {
    testTemplateRequest.sections = testTemplateRequest.sections.map(s => {
        if (testTemplateRequest.testSectionLevel == "none" || s.autoPickSelection) {
            s.courseSyllabusId = null;
        }

        return s;
    })
    return axios.post('rule/createRule', testTemplateRequest)
        .then((res: any) => {
            let temp: TestTemplateBody = res.responseObject;
            return Promise.resolve(temp);
        });
}
let updateTestTemplateType = (id: string, newName: any) => {
    return axios.patch('contentSubType/' + id, { name: newName })
        .then((res: any) => {
            return Promise.resolve();
        });

}
let updateNewTemplate = (testTemplateRequest: any) => {
    const templateFields = Object.values(TEST_TEMPLATE_CONFIG.FIELDS);
    templateFields.forEach((field: string) => {
        if (typeof (testTemplateRequest[field]) === 'object') {
            testTemplateRequest[field] = testTemplateRequest[field].key;
        }
    })


    let id = testTemplateRequest._id;
    testTemplateRequest.sections = testTemplateRequest.sections.map((s: any) => {
        if (testTemplateRequest.testSectionLevel == "none" || s.autoPickSelection) {
            s.courseSyllabusId = null;
        }

        return s;
    })
    return axios.patch(`rule/updateRule/${id}`, testTemplateRequest)
        .then((res: any) => {
            let temp: TestTemplateBody = res.responseObject;
            return Promise.resolve(temp);
        });
}



const getTypeOfGoal = (bucketType?: string) => {
    let url = 'course/getAvailableCourseListing';
    if (bucketType) url += `?bucketType=${bucketType}`;
    return axiosNT.get(url)
        .then((res: any) => {
            const goalOfList: TypeOfGoalBody[] = res.responseObject;
            return Promise.resolve(goalOfList);
        });
};

let getSubject = (id: any) => {
    let url = "subject";
    url += id ? id : "";
    return axiosNTL.get(url)
        .then((res: any) => {
            let goalOfList: TypeOfSubjectBody[] = res.responseObject;
            return Promise.resolve(goalOfList);
        });
};

let getContentSubType = (subTypeBy?: string, templateType?: string) => {
    let url = "contentSubType/getContentSubType";
    url += subTypeBy ? "/" + subTypeBy : "";
    url += templateType ? `?templateType=${templateType}` : ''
    return axiosNTL.get(url)
        .then((res: any) => {
            let goalOfList: ContentSubType[] = res.responseObject;
            return Promise.resolve(goalOfList);
        });
}


let getTestTemplateType = () => {
    return axios.get("testTemplateType/")
        .then((res: any) => {
            let testTemplateOfList: TypeOfTestTemplateBody[] = res.responseObject;
            return Promise.resolve(testTemplateOfList);
        });
}


let submitNewTestType = (testTypeRequest: any) => {
    return axios.post('contentSubType', testTypeRequest)
        .then((res: any) => {
            let temp: ContentSubType = res.responseObject;
            return Promise.resolve(temp);
        });
}

let deactiveTestType = (id: string) => {
    return axiosNTL.get(`contentSubType/deleteContentSubType/${id}`)
        .then((res: any) => {
            let temp = res.responseMessage ? res.responseMessage : "Something went wrong!";
            return Promise.resolve({ status: 1, msg: temp });
        })
        .catch((err) => {
            let temp = err.responseMessage ? err.responseMessage : "Something went wrong!";
            return Promise.resolve({ status: 0, msg: temp });
        })
}

let getAllSyllabus = (id: string, type: string) => {
    return axiosNTL.get(`courseSyllabus/getAll/${id}?type=${(type ? type : 'subject')}`)
        .then((res: any) => {
            return Promise.resolve(res.responseObject);
        })
}

export const testTemplateService = {
    getTestTemplateList,
    submitNewTemplate,
    getTypeOfGoal,
    getSubject,
    updateNewTemplate,
    getContentSubType,
    getTestTemplateType,
    submitNewTestType,
    deactiveTestType,
    getAllSyllabus,
    updateTestTemplateType,
}